module.exports = new __parcel__URL__("icon-new-window.c69f7f66.svg").toString();